import type {
    UscCarDeliveryTempConfig,
    UscCarDeliveryConfig,
    CarDeliveryDestination,
    CarDeliveryTransportationOption,
} from "../../utils/carDeliveryUtils";

export const USC_CAR_DELIVERY_SET_CONFIG = "uscCarDelivery/setConfig";
export type UscCarDeliverySetConfig = {
    type: typeof USC_CAR_DELIVERY_SET_CONFIG;
    deliveryConfig: UscCarDeliveryConfig | null;
};

// This action also causes carDeliveryLogic to be executed,
// which will store the final delivery config in sessionStorage.
export const setCarDeliveryConfig = (deliveryConfig: UscCarDeliveryConfig | null): UscCarDeliverySetConfig => ({
    type: USC_CAR_DELIVERY_SET_CONFIG,
    deliveryConfig,
});

export const USC_CAR_DELIVERY_MODAL_SET_NAV_STEP = "uscCarDelivery/modal/setNavStep";
export type UscCarDeliveryModalSetNavStep = {
    type: typeof USC_CAR_DELIVERY_MODAL_SET_NAV_STEP;
    navStep: number;
};
export const setCarDeliveryModalNavStep = (navStep: number): UscCarDeliveryModalSetNavStep => ({
    type: USC_CAR_DELIVERY_MODAL_SET_NAV_STEP,
    navStep,
});

export const USC_CAR_DELIVERY_SET_ERROR = "uscCarDelivery/setError";
export type UscCarDeliverySetError = {
    type: typeof USC_CAR_DELIVERY_SET_ERROR;
    error: boolean;
};
export const setCarDeliveryError = (error: boolean): UscCarDeliverySetError => ({
    type: USC_CAR_DELIVERY_SET_ERROR,
    error,
});

export const USC_CAR_DELIVERY_SET_TEMP_DELIVERY_CONFIG = "uscCarDelivery/setTempCarDeliveryConfig";
export type UscCarDeliverySetTempDeliveryConfig = {
    type: typeof USC_CAR_DELIVERY_SET_TEMP_DELIVERY_CONFIG;
    tempDeliveryConfig: UscCarDeliveryTempConfig | null;
};
export const setTempCarDeliveryConfig = (
    tempDeliveryConfig: UscCarDeliveryTempConfig | null,
): UscCarDeliverySetTempDeliveryConfig => ({
    type: USC_CAR_DELIVERY_SET_TEMP_DELIVERY_CONFIG,
    tempDeliveryConfig,
});

export const USC_CAR_DELIVERY_SET_DESTINATION = "uscCarDelivery/setDestination";
export type UscCarDeliverySetDestination = {
    type: typeof USC_CAR_DELIVERY_SET_DESTINATION;
    destination: CarDeliveryDestination;
};
export const setCarDeliveryDestination = (destination: CarDeliveryDestination): UscCarDeliverySetDestination => ({
    type: USC_CAR_DELIVERY_SET_DESTINATION,
    destination,
});

export const USC_CAR_DELIVERY_SET_TRANSPORTATION = "uscCarDelivery/setTransportation";
export type UscCarDeliverySetTransportation = {
    type: typeof USC_CAR_DELIVERY_SET_TRANSPORTATION;
    transportation: CarDeliveryTransportationOption;
};
export const setCarDeliveryTransportation = (
    transportation: CarDeliveryTransportationOption,
): UscCarDeliverySetTransportation => ({
    type: USC_CAR_DELIVERY_SET_TRANSPORTATION,
    transportation,
});

export type UscCarDeliveryActionsType =
    | UscCarDeliverySetConfig
    | UscCarDeliveryModalSetNavStep
    | UscCarDeliverySetTempDeliveryConfig
    | UscCarDeliverySetDestination
    | UscCarDeliverySetTransportation
    | UscCarDeliverySetError;
